export function constructMenuList({
  stage,
  itemType,
  hideWorkflow,
}: {
  stage: AssignmentStage | ''
  itemType: 'assignment' | 'private_doc'
  hideWorkflow: boolean
}) {
  const menu = []
  const isDownloadable = stage === 'approved' || itemType === 'private_doc'

  if (stage === 'finished') {
    menu.push({ key: 'approve', title: 'Approve', icon: 'lucide:check-circle' })
    menu.push({ key: 'rework', title: 'Rework', icon: 'tabler:refresh' })
  }

  if (itemType === 'private_doc' && !hideWorkflow) {
    menu.push({
      key: 'workflow_log',
      title: 'Workflow Log',
      icon: 'lucide:history',
    })
  }

  if (isDownloadable) {
    menu.push({ key: 'download', title: 'Download', icon: 'fe:download' })
  }

  if (itemType === 'private_doc') {
    menu.push({ key: 'delete', title: 'Delete', icon: 'uil:trash-alt' })
  }

  return menu
}
